import { action } from 'mobx';
import * as constants from '../../constants/constants';
import { getValueByNs } from '../../utils/utils';
import { log } from '../../utils/console';
import { RESPONSE_STATUS } from '../../common/constants/index';
import { sendAnalytics } from "../../utils/analytics";

export class AlterationsStore {
  rootStore = null;

  deletedGroups = [];

  getRemovedProductsData(item) {
    let products;
    if (item) {
      // Remove group of products
      if (item.type === 'group') {
        products = item.products;
      } else {
        // Remove single product
        products = [item];
      }
    } else {
      // Remove all products
      products = this.deletedGroups.reduce((result, group) => [...result, ...group.products], []);
      this.deletedGroups = [];
    }
    return products.reduce(
      (result, product) => {
        result.productId.push(product.ID);
        result.productQty.push(product.quantity);

        return result;
      },
      { productId: [], productQty: [] },
    );
  }

  syncRemove = async (item) => {
    const responseData = await this.rootStore.services.myProductsAPI.removeProduct(item ? item.ID : constants.DELETE_ALL);
    try {
      if (this.rootStore.optionsStore.immediateUiUpdates) {
        return responseData;
      }

      const responseStatus = getValueByNs(responseData, 'status');

      if (responseStatus.toUpperCase() === RESPONSE_STATUS.SUCCESS) {
        this.rootStore.uiStore.showNotification(constants.REMOVE);
        const eventType = constants.REMOVE;
        const productData = this.getRemovedProductsData(item);
        const quantity = productData.productQty;
        sendAnalytics({responseData, quantity, eventType, productData});
        return responseData;
      }

      return Promise.reject(new Error('Cannot sync product remove'));
    } catch (error) {
      log.warn(error);
    }
  }

  whenRemoveItem = ({ searchArr, item, group, contentText, withoutConfirm = false }) => {
    const removeData = { searchArr, item, group };

    if (withoutConfirm) {
      return this.forceRemoveItem(removeData);
    }

    return this.rootStore.confirmStore.openConfirm({ contentText }).then(() => {
      this.forceRemoveItem(removeData);
    });
  };

  whenRemoveAll = () =>
    this.rootStore.confirmStore
      .openConfirm({
        contentText: this.rootStore.labelsStore.allProducts,
      })
      .then(() => {
        // Save groups to be deleted to send products to analytics
        this.deletedGroups = [...this.rootStore.cartStore.allGroups];
        this.syncRemove();
      });

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @action.bound
  forceRemoveItem({ searchArr, item }) {
    const index = searchArr.findIndex((curItem) => curItem.ID === item.ID);

    if (index === -1) {
      return;
    }

    // Immediate UI update
    if (this.rootStore.optionsStore.immediateUiUpdates) {
      this.executeRemove(searchArr, index);
      return this.syncRemove(item);
    }

    this.changePendingState(item, constants.pendingState.pending.remove);

    return this.syncRemove(item).then(
      (response) => {
        if (this.rootStore.optionsStore.immediateUiUpdates) {
          return response;
        }

        this.executeRemove(searchArr, index);
      },
      () => {
        this.changePendingState(item, constants.pendingState.pendingRemoveError);
      },
    );
  }

  @action.bound
  executeRemove(searchArr, index) {
    searchArr.splice(index, 1);
  }

  @action.bound
  changePendingState(item, nextState) {
    item.changePendingState(nextState);
  }
}